import { useCallback, useState } from 'react';

import { parseISO, startOfDay } from 'date-fns';
import PropTypes from 'prop-types';

import Button, { ButtonAppearance, ButtonKind } from 'bloko/blocks/button';
import { FormSpacer } from 'bloko/blocks/form';

import useTrls from 'hooks/translation/useTrls';

import InputWithMultiDatePicker from 'components/InputWithMultiDatePicker';

import { useDispatch, useSelector } from 'store/utils';

import 'components/Admin/InvoiceDetail/Filter/Filter.less';

export const DEFAULT_FILTER_DATES = ({ createdAt }) => ({
    from: startOfDay(parseISO(createdAt)),
    to: startOfDay(new Date()),
});

const Filter = ({ invoiceId, fetchItems }) => {
    const invoice = useSelector((state) => state.invoiceDetail.invoice);

    const dispatch = useDispatch();

    const trl = useTrls();

    const [dates, setDates] = useState(DEFAULT_FILTER_DATES(invoice));
    const onFilterClick = useCallback(() => {
        dispatch(fetchItems(invoiceId, dates.from, dates.to));
    }, [dates, dispatch, fetchItems, invoiceId]);
    return (
        <div className="invoice-block-filter">
            <InputWithMultiDatePicker {...dates} action={(from, to) => setDates({ from, to })} />
            <div className="invoice-block-filter__actions">
                <FormSpacer>
                    <Button
                        appearance={ButtonAppearance.Outlined}
                        onClick={() => {
                            setDates(DEFAULT_FILTER_DATES(invoice));
                        }}
                    >
                        {trl('admin.Invoices.Filter.clear')}
                    </Button>
                </FormSpacer>
                <FormSpacer>
                    <Button kind={ButtonKind.Primary} onClick={onFilterClick}>
                        {trl('admin.Invoices.Filter.find')}
                    </Button>
                </FormSpacer>
            </div>
        </div>
    );
};

Filter.propTypes = {
    invoiceId: PropTypes.string,
    fetchItems: PropTypes.func,
};

export default Filter;
